import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Vérifier le token au chargement et tenter de récupérer les informations fraîches
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');

    const hydrateUser = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        // Essayer de récupérer /me pour avoir l'état à jour (is_admin, name...)
        const res = await axios.get('/api/auth/me', {
          headers: { Authorization: `Bearer ${token}` }
        });
        const freshUser = res.data;
        // Normaliser is_admin
        freshUser.is_admin = freshUser.is_admin ? 1 : 0;
        setUser(freshUser);
        localStorage.setItem('user', JSON.stringify(freshUser));
      } catch (err) {
        // Si /me échoue, retomber sur les données en localStorage si disponibles
        if (userData) {
          try {
            setUser(JSON.parse(userData));
          } catch (e) {
            console.error('Erreur parsing user:', e);
            logout();
          }
        } else {
          logout();
        }
      } finally {
        setLoading(false);
      }
    };

    hydrateUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    navigate('/login');
  };

  return { user, loading, logout };
}
